import type { Debts, EmployerContributionRow } from '../types/risk.types';

export type EmployerContributionsTableRow = {
  period: string;
  socialSecurityStatus: string;
  healthInsuranceStatus: string;
  employerHealthContributionStatus: string;
};

/** `periodMonth` viene como yyyymm (ej. 202503) → mostrar mm/yyyy */
function formatPeriodMonth(raw: string): string {
  const s = raw.trim();
  if (/^\d{6}$/.test(s)) {
    const y = s.slice(0, 4);
    const m = s.slice(4, 6);
    return `${m}/${y}`;
  }
  return s || '-';
}

function pickRowFields(row: EmployerContributionRow): EmployerContributionsTableRow {
  const noData = 'Sin datos';
  const rawPeriod = String(row.periodMonth ?? row.period_month ?? '');
  return {
    period: formatPeriodMonth(rawPeriod),
    socialSecurityStatus: String(
      row.socialSecurityStatus ?? row.social_security_status ?? noData
    ),
    healthInsuranceStatus: String(
      row.healthInsuranceStatus ?? row.health_insurance_status ?? noData
    ),
    employerHealthContributionStatus: String(
      row.employerHealthContributionStatus ??
        row.employer_health_contribution_status ??
        noData
    ),
  };
}

/** Filas para la tabla de aportes patronales (payload `debts` del BFF / origination). */
export function buildEmployerContributionsRows(
  debts: Debts | undefined,
  enabled: boolean
): EmployerContributionsTableRow[] {
  if (!enabled || !debts) {
    return [];
  }
  const raw = debts.employerContributions ?? debts.employer_contributions;
  if (!Array.isArray(raw) || raw.length === 0) {
    return [];
  }
  return raw.map(pickRowFields);
}
